import React from 'react';
import SIcon from './SIcon';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faEdit} fa />;

export default Icon;
